import _ from 'lodash'
import i18next from './i18n'

// List of initial user tour steps to show.
// Some steps are skipped based on the user type,
// by setting `disabled` to true.

export default user => _.reject([
  {
    title: i18next.t('TOUR.INTRO.TITLE'),
    text: `
      <p>${i18next.t('TOUR.INTRO.TEXT.PART_ONE')}</p>
      <p>${i18next.t('TOUR.INTRO.TEXT.PART_TWO')}<strong> ${i18next.t('TOUR.INTRO.TEXT.PART_THREE')}</strong> ${i18next.t('TOUR.INTRO.TEXT.PART_FOUR')}. <span style="color: #60c556;">${i18next.t('TOUR.INTRO.TEXT.PART_FIVE')}</span></p>
      <img
        width="350"
        height="170"
        src=${require('img/TourIntroImage.png')}
      />
    `,
    selector: '.help-tour',
    style: { main: { color: '#18262b' } },
    position: 'bottom-left',
    isFixed: true,
    autoStart: true,
  },
  {
    title: `${i18next.t('TOUR.STEP_ONE.TITLE')}`,
    text: `
      <p>${i18next.t('TOUR.STEP_ONE.TEXT')}</p>
      <img
        width="350"
        height="170"
        src=${require('img/TourStep11.png')}
      />
    `,
    selector: '.leaflet-gac-wrapper',
    style: { main: { color: '#18262b' } },
    position: 'bottom-right',
    isFixed: true,
    autoStart: true
  },
  {
    title: `${i18next.t('TOUR.STEP_TWO.TITLE')}`,
    text: `
      <p>${i18next.t('TOUR.STEP_TWO.TEXT.PART_ONE')}</p>
      <p>${i18next.t('TOUR.STEP_TWO.TEXT.PART_TWO')}<i>${i18next.t('TOUR.STEP_TWO.TEXT.PART_THREE')}</i> ${i18next.t('TOUR.STEP_TWO.TEXT.PART_FOUR')} <strong>${i18next.t('TOUR.STEP_TWO.TEXT.PART_FIVE')}</strong>. ${i18next.t('TOUR.STEP_TWO.TEXT.PART_SIX')} <i>${i18next.t('TOUR.STEP_TWO.TEXT.PART_SEVEN')}</i>. ${i18next.t('TOUR.STEP_TWO.TEXT.PART_EIGHT')} <strong>${i18next.t('TOUR.STEP_TWO.TEXT.PART_NINE')}</strong> ${i18next.t('TOUR.STEP_TWO.TEXT.PART_TEN')}</p>
      <p>${i18next.t('TOUR.STEP_TWO.TEXT.PART_ELEVEN')} <strong>${i18next.t('TOUR.STEP_TWO.TEXT.PART_TWELVE')}</strong>.</p>
      <p>${i18next.t('TOUR.STEP_TWO.TEXT.PART_THIRTEEN')} <strong>${i18next.t('TOUR.STEP_TWO.TEXT.PART_FOURTEEN')}</strong> ${i18next.t('TOUR.STEP_TWO.TEXT.PART_FIFTHEEN')}</p>
      <img
        width="370"
        height="170"
        src=${require('img/TourStep2.png')}
      />`,
    selector: '.sub-tools .add-buffer-point',
    style: { main: { color: '#18262b' } },
    position: 'right',
    isFixed: true,
    autoStart: true
  },
  {
    title: `${i18next.t('TOUR.STEP_THREE.TITLE')}`,
    text: `
      <p>${i18next.t('TOUR.STEP_THREE.TEXT.PART_ONE')} <strong>${i18next.t('TOUR.STEP_THREE.TEXT.PART_TWO')}</strong>, ${i18next.t('TOUR.STEP_THREE.TEXT.PART_THREE')} <i>${i18next.t('TOUR.STEP_THREE.TEXT.PART_FOUR')}</i>, ${i18next.t('TOUR.STEP_THREE.TEXT.PART_FIVE')} <i>${i18next.t('TOUR.STEP_THREE.TEXT.PART_SIX')}</i>, ${i18next.t('TOUR.STEP_THREE.TEXT.PART_SEVEN')} <i>${i18next.t('TOUR.STEP_THREE.TEXT.PART_EIGHT')}</i> ${i18next.t('TOUR.STEP_THREE.TEXT.PART_NINE')}.</p>
      <img
      width="370"
      height="170"
      src=${require('img/TourStep3.png')}
    />
    `,
    selector: '.map-settings',
    style: { main: { color: '#18262b' } },
    position: 'right',
    isFixed: true,
    autoStart: true
  },
  {
    title: `${i18next.t('TOUR.STEP_FOUR.TITLE')}`,
    text: `
      <p>${i18next.t('TOUR.STEP_FOUR.TEXT.PART_ONE')} <strong>${i18next.t('TOUR.STEP_FOUR.TEXT.PART_TWO')}</strong> ${i18next.t('TOUR.STEP_FOUR.TEXT.PART_THREE')}. ${i18next.t('TOUR.STEP_FOUR.TEXT.PART_FOUR')} <i>${i18next.t('TOUR.STEP_FOUR.TEXT.PART_FIVE')}</i> ${i18next.t('TOUR.STEP_FOUR.TEXT.PART_SIX')}.</p>
      <p>${i18next.t('TOUR.STEP_FOUR.TEXT.PART_SEVEN')} <a style="color: #0099FF; text-decoration: none;" href="${process.env.CORPORATE_URL}/resources/learn/shapefiles-and-markers/">${i18next.t('TOUR.STEP_FOUR.TEXT.PART_EIGHT')}</a></p>
      <img
      width="370"
      height="170"
      src=${require('img/TourStep4.png')}
    />
    `,
    selector: '.my-data',
    style: { main: { color: '#18262b' } },
    position: 'right',
    isFixed: true,
    autoStart: true
  },
  {
    title: `${i18next.t('TOUR.STEP_FIVE.TITLE')}`,
    text: `
      <p>${i18next.t('TOUR.STEP_FIVE.TEXT.PART_ONE')} <a style="color: #0099FF;text-decoration: none;" href="${process.env.CORPORATE_URL}/resources/learn/">${i18next.t('TOUR.STEP_FIVE.TEXT.PART_TWO')}</a> ${i18next.t('TOUR.STEP_FIVE.TEXT.PART_THREE')} <a style="color: #0099FF;text-decoration: none;" href="mailto:support@populationexplorer.com">support@populationexplorer.com</a></p>
      <p>${i18next.t('TOUR.STEP_FIVE.TEXT.PART_FOUR')} <strong>[?] ${i18next.t('TOUR.STEP_FIVE.TEXT.PART_FIVE')}</strong>, ${i18next.t('TOUR.STEP_FIVE.TEXT.PART_SIX')}</p>
      <img
        width="370"
        height="170"
        src=${require('img/TourStep5.png')}
      />
    `,
    selector: '.help-tour',
    style: { main: { color: '#18262b' } },
    position: 'bottom-left',
    isFixed: true,
    autoStart: true
  }
], { disabled: true })
